import { render, staticRenderFns } from "./NVLTable.vue?vue&type=template&id=2d21cd49&scoped=true&"
import script from "./NVLTable.vue?vue&type=script&lang=js&"
export * from "./NVLTable.vue?vue&type=script&lang=js&"
import style0 from "./NVLTable.vue?vue&type=style&index=0&id=2d21cd49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21cd49",
  null
  
)

export default component.exports